import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  input,
} from '@angular/core';

import { ImageThumbnailSize } from '../../types/image-thumbnail-size';
import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';

@Component({
  selector: 'app-image-thumbnail',
  imports: [],
  templateUrl: './image-thumbnail.component.html',
  styleUrl: './image-thumbnail.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageThumbnailComponent {
  public readonly size = input<ImageThumbnailSize>('default');
  public readonly rounded = input<boolean>(true);

  private readonly cssClasses = new Map<ImageThumbnailSize, string>([
    ['default', 'size-16'],
    ['full', 'size-full'],
    ['lg', 'size-32'],
    ['md', 'size-24'],
    ['sm', 'size-10'],
    ['xl', 'size-72'],
    ['xxl', 'size-96'],
  ]);

  @HostBinding('class.rounded-sm')
  public get roundedCssClass(): boolean {
    return this.rounded();
  }

  @HostBinding('class')
  public get sizeCssClass(): string {
    const key = this.size();
    const cssClass = this.cssClasses.get(this.size());

    if (isNil(cssClass)) {
      throw new EntryNotFoundException(
        `The entry for key "${key}" is not found.`,
      );
    }

    return cssClass;
  }
}
